import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, Form, FormFeedback, FormGroup, Label } from 'reactstrap'
import { Button, Textarea } from 'dsm-react-lib'
import ReactStars from 'react-stars'
import { useReviewService, useAppsService } from '../../_services/_index'
import { appInsights } from '../../_services/AppInsights'
import { EventType } from '../../utility/types'
import { useTrackEvent } from '@microsoft/applicationinsights-react-js'
import { MANDG_GDPR_REVIEWS } from '../../configs/constants'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import { toast } from 'react-toastify'
import { IconX } from '@tabler/icons-react'
import { StyledModalHeader } from '../_templates/ContributorModal'

const ReviewsModal = ({ setApplication, isOpen, toggle, applicationId, uniqueName }) => {
  const { register, errors, handleSubmit, trigger } = useForm()

  const [rating, setRating] = useState()
  const [review, setReview] = useState('')
  const [isReviewSubmitted, setIsReviewSubmitted] = useState(false)
  const { addReviewOnApplication } = useReviewService()
  const { getApplication } = useAppsService()
  const trackAppRated = useTrackEvent(appInsights, EventType.AppRated)

  const onReviewChange = (e) => {
    setReview(e.target.value)
  }

  const onRatingChange = (e) => {
    e === null ? setRating(undefined) : setRating(e)
  }

  const onSubmit = async (e) => {
    if (rating === undefined) setRating(null)
    const isValid = await trigger()
    if (isValid && rating !== undefined && rating !== null) {
      setIsReviewSubmitted(true)
      const { sid } = JSON.parse(localStorage.getItem('userInfoData'))

      const request = {
        appReview: review,
        rating,
        applicationId,
        userSid: sid
      }

      try {
        const response = await addReviewOnApplication(request)
        if (
          response &&
          Object.keys(response).length > 0 &&
          response?.applicationId === applicationId
        ) {
          const app = await getApplication(uniqueName)
          setApplication(app.data)
          toast.success('Application review sent successfully.')
          trackAppRated({
            appRating: `Application with id ${applicationId} is rated with ${rating} rating`,
            properties: {
              name: app?.name,
              rating
            }
          })
        }
        toggle()
      } catch (error) {
        console.error(`An unexpected error occured ${error}.`)
        toast.error('An error occurred while sending the review.')
      }
    }
  }

  return (
    <>
      <div className="vertically-centered-modal">
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          className="modal-dialog-centered custom-modal-dialog">
          <StyledModalHeader
            toggle={toggle}
            close={
              <IconX
                size={24}
                color="var(--icon-muted)"
                onClick={toggle}
                className="cursor-pointer"
              />
            }>
            Write a review
          </StyledModalHeader>
          <ModalBody>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-1">
                <Label>Star rating</Label>
                <ReactStars
                  id="rating"
                  name="rating"
                  count={5}
                  onChange={onRatingChange}
                  size={24}
                  color2={'#ffd700'}
                  value={rating}
                  half={false}
                  className={classnames({ 'is-invalid': rating === null })}
                />
                {rating === null && <FormFeedback>Star rating is required.</FormFeedback>}
              </div>
              <div className="mb-2">
                <Label for="review-text">Tell us what you think about this app</Label>
                <Textarea
                  id="review"
                  name="review"
                  placeholder="Write a review"
                  rows={3}
                  minLength={20}
                  onChange={onReviewChange}
                  maxLength={150}
                  ref={register({ required: true })}
                  invalid={'review' in errors}
                  helperText={'review' in errors ? 'Review comment is required.' : ''}
                />
              </div>
              {MANDG_GDPR_REVIEWS}
              <Button
                type="submit"
                onClick={onSubmit}
                label="Accept"
                className="float-right mt-2"
                color="primary"
                disabled={isReviewSubmitted}
              />
            </Form>
          </ModalBody>
        </Modal>
      </div>
    </>
  )
}
export default ReviewsModal
